module.exports = __webpack_public_path__ + "img/34_2.b3cac1df.png";